import { IntBillCommentsQuickInfo } from "../IntBillCommentsQuickInfo";
import { DataSource, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutBillingCommentsQuickInfo extends Layout {
    layoutExtBillCommentsQuickInfo: Layout;
    layoutIntBillCommentsQuickInfo: IntBillCommentsQuickInfo;
    panelAllComments: Panel;
    sourceBillingComments: DataSource;
}
